<template>
  <div>
    <cv-header aria-label="pintura-header">
      <div class="select-printposition">
        <cv-dropdown
          v-if="!isDisabled"
          id="print-positions"
          ref="pp-dropdown"
          v-on-clickaway="onClickAway"
          :disabled="!selectedPrintPosition || isHeaderDisabled"
          :placeholder="$t('pintura.header.choose-position')"
          :value="selectedPrintPosition.id"
          @change="(id) => changePrintPosition(id)"
        >
          <cv-dropdown-item
            v-for="position in printPositions"
            :key="position.id"
            :value="position.id"
          >
            {{ position.name }}
          </cv-dropdown-item>
        </cv-dropdown>
      </div>
      <div id="add-print-position" class="add-printposition">
        <cv-button
          :icon="Add32"
          kind="ghost"
          class="add-printposition-button"
          :disabled="isHeaderDisabled"
          @click="$emit('positions:add')"
        >
          {{ $t('sidebar.add-print-position') }}
        </cv-button>
      </div>
    </cv-header>
  </div>
</template>
<script>
import Vue from 'vue';

import { CvHeader, CvDropdown, CvButton, CvDropdownItem } from '@carbon/vue';
import Add32 from '@carbon/icons-vue/es/add/32';
import { useStore as useProductStore } from '@/stores/product';
import { useStore as useShapeStore } from '@/stores/shape';
import { useStore as useHistoryStore } from '@/stores/history';
import { useStore as useNotificationStore } from '@/stores/notification';
import { useStore as useColorsManagementStore } from '@/stores/colorsManagement';

import { mapState, mapActions } from 'pinia';
import { mixin as clickaway } from 'vue-clickaway';
import { createStateSnapshot } from '@/utils/historyHelper';

export default Vue.extend({
  name: 'PinturaSidebarHeader',

  components: {
    CvHeader,
    CvDropdown,
    CvButton,
    CvDropdownItem,
  },

  mixins: [clickaway],

  props: {
    buttonLabel: {
      type: String,
      default: '',
    },
    isHeaderDisabled: {
      type: Boolean,
      required: true,
    },
  },

  data: () => {
    return { Add32 };
  },

  computed: {
    ...mapState(useProductStore, [
      'printPositions',
      'selectedPrintPosition',
      'unavailablePrintPositions',
      'data',
    ]),
    ...mapState(useNotificationStore, ['notificationsForBell']),

    isDisabled() {
      return this.unavailablePrintPositions.length === 0;
    },
  },

  methods: {
    ...mapActions(useProductStore, [
      'setActivePrintPosition',
      'isLaserConverter',
    ]),
    ...mapActions(useShapeStore, ['deselectShape']),
    ...mapActions(useColorsManagementStore, ['getAvailablePmsColors']),
    ...mapActions(useHistoryStore, ['recordHistory']),
    ...mapActions(useNotificationStore, [
      'setLaserRemarkNotification',
      'setCommercialRemarkNotification',
    ]),
    async changePrintPosition(id) {
      const createSnapshot = this.selectedPrintPosition.id !== id;
      const activePrintPosition = this.unavailablePrintPositions.find(
        (position) => position.positionId === id
      );

      this.setActivePrintPosition(activePrintPosition);

      const printPostion = this.data.productPrintPositions?.find(
        (p) => p.id === id
      );

      this.setCommercialRemarkNotification();

      await this.getAvailablePmsColors();

      this.deselectShape();

      if (createSnapshot) {
        const snapshot = createStateSnapshot();
        this.recordHistory(snapshot);
      }
    },
    onClickAway() {
      const dropdownEl = this.$refs['pp-dropdown'];
      dropdownEl.onClickout();
    },
  },
});
</script>

<style lang="scss">
@import '../../../../styles/carbon-utils';
@import '../../../../styles/carbon-overrides.scss';

.cv-header.bx--header {
  z-index: 0;
  background-color: #f4f4f4;
  border-bottom: none;
  height: 48px;

  .bx--form-item {
    width: 50%;
    flex: unset;
  }
}

.select-printposition {
  display: flex;
  justify-content: flex-start;
  flex-grow: 8;
  height: 48px;
}

.select-printposition .bx--list-box__label,
.select-printposition .bx--form-item {
  font-size: 14px;
}

.add-printposition {
  height: 48px;
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;

  &-button {
    @include carbon--type-style('body-short-01');
    width: 100%;
    font-size: 14px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
